<template>
	<section id="title_section" class="section">
		<div class="section_content">
			<div id="title_container">
				<h1 class="my_name no_text_select">Daniel-Junior Dubé</h1>
				<h2 class="under_my_name no_text_select">Portfolio</h2>
				<div class="title_social_media_links no_text_select">
					<hr>
					<ul>
						<li v-for="socialMediaLink in socialMediaLinks" :key="socialMediaLink.url">
							<a :href=socialMediaLink.url>
								<i
									:class=socialMediaLink.class
									:style="{color: socialMediaLink.color}"
									aria-hidden="true">
								</i>
							</a>
						</li>
						<li>
							<a href="https://drive.google.com/file/d/1yqZrAZvo4KqFtTkEdqbPMkevAYBQAI6r/view?usp=sharing">
								<span>Curriculum Vitae</span>
								<i class="fas fa-file-pdf"></i>
							</a>
						</li>
					</ul>
				</div>
				<!-- TODO: Add "employment status" under "social media" -->
				<!-- TODO: Add "learn more about me" at bottom, centered -->
			</div>
		</div>
		<a href="#" class="scrollto_next" v-scroll-to="{
				el: '#experiences_section',
				duration: scrollToSpeed,
				easing: 'ease-in-out'
		}">
			<i class="fas fa-2x fa-angle-double-down" aria-hidden="true"></i>
		</a>
	</section>
</template>

<script>
	import VueScrollTo from 'vue-scrollto';

	export default {
		name: "LandingPageTitleSection",
		props: ["scrollToSpeed"],
		data () {
			return {
				socialMediaLinks: [
					{ url: 'https://twitter.com/HEYIMFUZZ', class: "fab fa-twitter", color: "#55acee" },
					{ url: 'https://github.com/daniel-junior-dube', class: "fab fa-github", color: "#fff" },
					{ url: 'https://www.facebook.com/junior.dube.5', class: "fab fa-facebook", color: "#3B5998" },
					{ url: 'https://www.linkedin.com/in/daniel-junior-dubé-418a3381', class: "fab fa-linkedin", color: "#0077b5" },
				]
			}
		},
		directives: {
			scrollTo: VueScrollTo
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/global.scss";
	@import "../../styles/text_mixins.scss";
	@import "../../styles/background_mixins.scss";
	@import "../../styles/transition_mixins.scss";
	@import "../../styles/spacing_mixins.scss";

	.section {
		min-height: 100vh;
		align-items: center;
		flex-direction: column;
		@include background-image(
			url(/static/images/landing_bg.png),
			right bottom,
			no-repeat,
			auto 95%
		);
		& .section_content {
			& #title_container {
				display: inline-flex;
				flex-direction: column;
				@include spacing( 0, 25px );
				.my_name {
					@include spacing( 0px 0px 10px 0px, 0px );
					@include text(
						$font-size: 3.8em,
						$shadow: 5px 5px 20px $less_transparent_black,
						$transform: uppercase,
						$font-weight: bold
					);
				}
				.under_my_name {
					font-weight: 400;
					@include spacing( 0px 0px 5px 0px, 0px );
					@include text(
						$font-size: 2.5em,
						$shadow: 5px 5px 20px $less_transparent_black,
						$transform: uppercase
					);
				}
				.title_social_media_links {
					ul {
						padding: 0px;
						list-style: none;
						list-style-type: none;
						min-height: 44px;
						li {
							display: flex;
							justify-content: center;
							align-items: center;
							float: left;
							margin-right: 4px;
							margin-bottom: 4px;
							a {
								display: flex;
								text-decoration: none;
								justify-content: center;
								align-items: center;
								text-align: center;
								min-width: 44px;
								height: 44px;
								color: white;
								@include transition( 0.2s ease );
								span {
									margin-top: 6px;
									padding: 10px 0px 10px 10px;
								}
								i {
									font-size: 1.5em;
									@include spacing( 0px, 10px );
								}
								&:hover span, &:hover i {
									@include transition( 0.1s ease );
									color: black;
								}
								&:hover .fa-github {
									color: black !important;
								}
								@include background(
									$color: $less_transparent_black,
									$border-radius: 2px
								);
								&:hover {
									@include background( $color: $light_contrast, $border-radius: 2px );
									@include transition( 0.1s ease );
								}
							}
						}
					}
				}
			}
		}
	}

	@media (max-width: 1024px) {
		.section {
			& .section_content {
				display: flex;
				justify-content: center;
			}
		}
	}

	@media (min-width: 320px) and (max-width: 500px) {
		.section {
			& .section_content {
				& #title_container {
					.my_name {
						font-size: 3.0em;
					}
					.under_my_name {
						font-size: 2.0em;
					}
				}
			}
		}
	}

	@media (max-width: 321px) {
		.section {
			& .section_content {
				& #title_container {
					.my_name {
						font-size: 2.8em;
					}
					.under_my_name {
						font-size: 1.8em;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/landingPage/titleSection.vue